import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import moment from 'moment';
import MoreFilters from './MoreFilters';
import DateInput from '../DateInput/DateInput';
import Input from '../Input/Input';

import METADATA_DEFINITIONS from './metadataDefinitions';

export default class MoreFiltersExample extends Component {

  constructor(props) {
    super(props);
    this.onApply = window.showAppInfo.bind(null, 'apply filter');
    this.onClear = window.showAppInfo.bind(null, 'clear');
    this.state = {
      buttonClass: 'tertiary',
      metadataDefinitions: METADATA_DEFINITIONS,
      date: moment(),
      field: '',
      metadata: {},
    };
  }

  onClick = () => {
    window.showAppInfo('open more filters ');
    this.updateSource();
  };

  onChange = e => this.setState({ metadata: e.target.value });

  onChangeProps = e => this.setState(e.target.value);

  onChangeField = e => this.setState({ field: e.target.value });

  onDateChange = date => this.setState({ date });

  updateSource = () =>
    setTimeout(() => {
      this.forceUpdate();
    }, 1);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChangeProps} defaultProps={MoreFilters.defaultProps} propTypes={MoreFilters.propTypes}
          propValues={this.state}/>
        <MoreFilters {...this.state} onApply={this.onApply} onClear={this.onClear} onClick={this.onClick}
          onClose={this.updateSource} metadataDefinitions={this.state.metadataDefinitions} onChange={this.onChange}
          metadata={this.state.metadata}>
          <label htmlFor="input">Input</label>
          <Input id="input" placeholder="Custom input field" onChange={this.onChangeField} value={this.state.field} disabled={this.state.disabled}/>
          <label htmlFor="date">Date</label>
          <DateInput id="date" onChange={this.onDateChange} placeholder="Custom date field" selected={this.state.date} disabled={this.state.disabled}/>
        </MoreFilters>
        <SourceCode querySelector=".core-more-filters"/>
      </Example>
    );
  }

}
